<template>
  <div class="p-3">
    <div class="mb-2">{{$t("AppPreset")}}</div>
    <div class="app-preset">
      <div class="form-group">
        <legend>{{$t("Size")}}</legend>
        <div>
          <b-button
            v-for="item in fontSizeOptions"
            :key="item.value"
            variant="outline-preset"
            @click="onSizeChange(item.value)"
            :class="{'btn-active': preset.FontSize === item.value}"
          >{{ item.text }}</b-button>
        </div>
      </div>

      <b-form-group :label="$t('Theme')">
        <b-form-radio
          v-for="item in themeOptions"
          :key="item.value"
          v-model="preset.Theme"
          name="some-radios"
          :value="item.value"
        >{{ item.text }}</b-form-radio>
      </b-form-group>

      <b-form-group :label="$t('DateTimeFormat')">
        <b-form-radio
          v-for="item in localDateTimeFormatOptions"
          :key="item.id"
          name="date-time-format-radios"
          v-model="rhmPreset.DateTimeFormat"
          :value="item.value"
          >{{ item.text }}</b-form-radio
        >
      </b-form-group>

      <b-button variant="success" @click="savePreset" class="w-75 mb-1">{{$t("buttons.Save")}}</b-button>
      <b-button variant="light" @click="removePreset" class="w-75">{{$t("buttons.Default")}}</b-button>
    </div>
  </div>
</template>

<script>
import api from "@/api/visary-api";
import rhmApi from "@/api/rhm-api";
import { setLocale, defaultLanguage } from "@/shared/i18n";

export default {
  name: "vis-app-preset",
  data() {
    return {
      preset: {},
      rhmPreset: {},
      fontSizeOptions: [
        { value: 0, text: "S", className: "vis-font-sm" },
        { value: 10, text: "M", className: "vis-font-md" },
        { value: 20, text: "L", className: "vis-font-lg" }
      ],
      themeOptions: [
        { value: 0, text: this.$t("themes.default"), className: "vis-theme" },
        { value: 10, text: this.$t("themes.state"), className: "vis-state" }
      ],
      localDateTimeFormatOptions: [
        {
          id: 1,
          value: {
            DateTime: "DD.MM.YYYY HH:mm:ss",
            Date: "DD.MM.YYYY",
            DxDateTime: "dd.MM.yyyy HH:mm:ss",
            DxDate: "dd.MM.yyyy"
          },
          text: this.$moment(Date.now()).format("DD.MM.YYYY hh:mm:ss")
        },
        {
          id: 2,
          value: {
            DateTime: "DD/MM/YYYY HH:mm:ss",
            Date: "DD/MM/YYYY",
            DxDateTime: "dd/MM/yyyy HH:mm:ss",
            DxDate: "dd/MM/yyyy"
          },
          text: this.$moment(Date.now()).format("DD/MM/YYYY hh:mm:ss")
        },
        {
          id: 3,
          value: {
            DateTime: "MM/DD/YYYY HH:mm:ss",
            Date: "MM/DD/YYYY",
            DxDateTime: "MM/dd/yyyy HH:mm:ss",
            DxDate: "MM/dd/yyyy"
          },
          text: this.$moment(Date.now()).format("MM/DD/YYYY hh:mm:ss")
        },
        {
          id: 4,
          value: {
            DateTime: "YYYY-DD-MM HH:mm:ss",
            Date: "YYYY-DD-MM",
            DxDateTime: "yyyy-dd-MM HH:mm:ss",
            DxDate: "yyyy-dd-MM"
          },
          text: this.$moment(Date.now()).format("YYYY-MM-DD hh:mm:ss")
        }
      ]
    };
  },
  methods: {
    async bindPreset() {
      this.preset = await this.getPreset();
      this.rhmPreset = await rhmApi.preset.getAppPreset();
      this.setPreset();
    },
    async savePreset() {
      this.preset = await api.preset.saveAppPreset(this.preset);
      this.rhmPreset = await rhmApi.preset.saveAppPreset(this.rhmPreset);
      this.setPreset();
    },
    async removePreset() {
      await api.preset.deleteAppPreset();
      await rhmApi.preset.deleteAppPreset();
      await this.bindPreset();
      await this.setDefaultLanguage();
    },
    async getPreset() {
      return await api.preset.getAppPreset();
    },
    setPreset() {
      this.setFontSizeClass();
      this.setThemeClass();
    },
    setFontSizeClass() {
      var fontSize = this.preset.FontSize;
      for (var item of this.fontSizeOptions) {
        if (item.value === fontSize) {
          document.documentElement.classList.add(item.className);
        } else {
          document.documentElement.classList.remove(item.className);
        }
      }
    },
    setThemeClass() {
      var theme = this.preset.Theme;
      for (var item of this.themeOptions) {
        if (item.value === theme) {
          document.documentElement.classList.add(item.className);
        } else {
          document.documentElement.classList.remove(item.className);
        }
      }
    },
    onSizeChange(value) {
      this.preset.FontSize = value;
    },
  },
  async created() {
    document.documentElement.classList.add("loading");
    await this.bindPreset();
    document.documentElement.classList.remove("loading");
  }
};
</script>
